import React, { useState } from "react";
import "./activation-steps.scss";
import WhiteArrow from "../../../assets/Icons/WhiteArrow";

const ActivationSteps = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="activation-steps-section">
      <div className="activation-steps-wrapper">
        {/* Header */}
        <div className="activation-header">
          <h4 className="activation-heading">Activation Steps</h4>
          <button
            className={`toggle-btn ${isOpen ? "open" : "closed"}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            <WhiteArrow />
          </button>
        </div>

        {/* Body */}
        {isOpen && (
          <div className="activation-body">
            <div className="activation-content">

              <h3><strong>🚀 Activate Your eSIM in Just a Few Easy Steps!</strong></h3>
<br/>
              <p>
                <strong>🔎 Step 1: Check Device Compatibility</strong><br />
                Before you dive in, make sure your device is eSIM-ready.
              </p>
              <ul> 
                <li>Check our Teleport Now eSIM Compatibility List</li>
                <li>Explore your device settings</li>
                <li>Visit your device manufacturer’s website</li>
              </ul>
<br/>
              <p>
                <strong>📲 Step 2: Install Your eSIM</strong><br />
                Choose the install method that works best for you — we keep it simple!
              </p>
<br/>

              <p>
                <strong>⚡ One-Click Install (via App)</strong><br />
                Just tap <em>Install</em> in the Teleport Now app. Boom 💥 — it’ll route you straight
                to your phone settings to set up your eSIM.
              </p>
<br/>

              <p>
                <strong>📷 QR Code Install</strong>
                <br />
                Open <em>Settings &gt; Mobile/Cellular &gt; Add eSIM</em><br />
                Select <em>Scan QR Code</em> and scan away!
              </p>
              <p>
                ✨ Pro tip: If your QR code is saved in your photo gallery, just tap &amp; hold
                the image — your phone will detect it instantly.
              </p>
<br/>

              <p>
                <strong>⌨️ Manual Install</strong>
                <br />
                Go to <em>Settings &gt; Mobile/Cellular &gt; Add eSIM</em><br />
                Select <em>Enter Details Manually</em><br />
                Copy &amp; paste the info we provide — done!
              </p>
<br/>
              <h3>🎉 That’s It! You’re now connected ⚡ and ready to explore the world!</h3>

            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ActivationSteps;
